import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.json";
import zht from "./zh-t.json";

Vue.use(VueI18n);

// const getCookie = key => {
//   var v = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
//   return v ? v[2] : null;
// };

// const getLang = () => getCookie("lang");

// let lang = getLang();

let lang = "en";

export const languages = [
  { title: "繁體中文", value: "zh-t" },
  { title: "English", value: "en" }
];

export default new VueI18n({
  locale: lang,
  fallbackLocale: "en",
  messages: {
    en: en,
    "zh-t": zht
  }
});
